import React from "react";
import Hero from "../Hero";
import MarqueeDiv from "../Marquee";
import Services from "../Servicies";
import Reviews from "../Reviews";
import Contact from "../Contact";

const Home = () => {
  return (
    <>
      <Hero />
      <MarqueeDiv />
      <Services />
      <Reviews />
      <Contact />
    </>
  );
};

export default Home;
